const CREATIVE_GALLERY_ENDPOINTS = {
  MOVE_VIDEO: (brand: string, video_id: string): string =>
    `/brands/${brand}/videos/${video_id}`,
  IMPORT: (brand: string): string => `/brands/${brand}/videos/import`,
  ROOT_GALLERY: (brand: string): string => `/brands/${brand}/folders`,
  NEW_FOLDER: (brand: string): string => `/brands/${brand}/folders`,
  FOLDER_DETAILS: (brand: string, folder_id: string): string =>
    `/brands/${brand}/folders/${folder_id}`,
  ARCHIVE: (brand: string): string => `/brands/${brand}/archive`
};

export default CREATIVE_GALLERY_ENDPOINTS;
